module.exports = __webpack_public_path__ + "media/images/pic/certificates/forum-firm-a7cced941e4efdf6deb6c7871dbafff9.png";